import React, { useMemo, useState, useEffect } from "react";
import { motion } from "framer-motion";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Countdown from "../components/Countdown";
import OurStory from "../components/OurStory";
import Family from "../components/Family";
import Program from "../components/Program";
import Venue from "../components/Venue";
import DressCode from "../components/DressCode";
import Attention from "../components/Attention";
import RSVPForm from "../components/RSVPForm";
import Footer from "../components/Footer";
import CurtainIntro from "../components/CurtainIntro";
import Butterflies from "../components/Butterflies";
import { useAudio } from "../context/AudioContext";

// Stable constants — defined once outside the component to avoid
// re-creating objects on every render.
const REVEAL_TRANSITION = { duration: 1.3, ease: [0.22, 1, 0.36, 1] };
const REVEAL_STYLE = { transformOrigin: "center top" };

export default function HomePage() {
  const { start } = useAudio();
  // Always show the curtain intro on every fresh load — no persistence.
  const [introDone, setIntroDone] = useState(false);
  const [reveal, setReveal] = useState(false);

  useEffect(() => {
    if (!introDone) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
      // Trigger soft-focus reveal on next frame for smooth transition
      const id = requestAnimationFrame(() => setReveal(true));
      return () => cancelAnimationFrame(id);
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [introDone]);

  const handleOpen = () => {
    setIntroDone(true);
    start();
  };

  const revealAnimate = useMemo(
    () => ({
      filter: reveal ? "blur(0px)" : "blur(14px)",
      opacity: reveal ? 1 : 0.35,
      scale: reveal ? 1 : 1.03,
    }),
    [reveal]
  );

  return (
    <div className="paper-texture vignette relative" data-testid="home-page">
      {!introDone && <CurtainIntro onOpen={handleOpen} />}
      <motion.div
        initial={false}
        animate={revealAnimate}
        transition={REVEAL_TRANSITION}
        style={REVEAL_STYLE}
      >
        <Header />
        <main>
          <Hero />
          <Countdown />
          <OurStory />
          <Family />
          <Program />
          <Venue />
          <DressCode />
          <Attention />
          <RSVPForm />
        </main>
        <Footer />
      </motion.div>
      {introDone && <Butterflies />}
    </div>
  );
}
